import { render } from "./MainTilePanel.vue?vue&type=template&id=d339a222"
import script from "./MainTilePanel.vue?vue&type=script&lang=js"
export * from "./MainTilePanel.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_f9a89c39/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__